module.exports = __webpack_public_path__ + "img/Sketch_Logo.d93faad1.svg";